<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.88658 4.56409C3.74994 4.43109 3.52445 4.45767 3.44434 4.63071C3.28162 4.98216 3.19434 5.36283 3.19434 5.75793V19.2579C3.19434 19.6576 3.28408 20.0358 3.44023 20.3777C3.51967 20.5517 3.74582 20.579 3.88292 20.4457L11.8263 12.7219C11.9474 12.6041 11.9475 12.4096 11.8264 12.2918L3.88658 4.56409Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9144 11.2576C13.0308 11.3709 13.2163 11.371 13.3328 11.2577L15.9902 8.67355C16.1341 8.53367 16.1027 8.29474 15.9276 8.19671L7.29349 3.36218C6.65249 3.00218 5.91149 2.91418 5.20049 3.11218C5.17602 3.11909 5.15174 3.1264 5.12763 3.13404C4.92984 3.19677 4.88994 3.44648 5.03862 3.59121L12.9144 11.2576Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3322 13.7574C13.2157 13.6441 13.0302 13.6441 12.9138 13.7573L5.03565 21.4177C4.88737 21.5619 4.92676 21.8094 5.12323 21.874C5.38271 21.9594 5.65818 22.0079 5.94708 22.0079C6.40208 22.0079 6.86208 21.8909 7.28208 21.6649L15.9599 16.8546C16.1358 16.7571 16.1678 16.5175 16.0237 16.3772L13.3322 13.7574Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.46 11.2181C20.217 10.7761 19.853 10.4051 19.398 10.1411L17.8243 9.26005C17.708 9.19491 17.563 9.21401 17.4678 9.30745C16.9662 9.80013 15.4005 11.3373 14.4198 12.2931C14.2989 12.411 14.2988 12.6053 14.4197 12.7232C15.4118 13.691 17.0028 15.2535 17.5084 15.7503C17.6032 15.8434 17.7477 15.8629 17.864 15.7985L19.385 14.9551C20.028 14.6011 20.494 14.0151 20.697 13.3061C20.9 12.5981 20.815 11.8551 20.46 11.2181Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconGooglePlay",
};
</script>
